import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
//import { debounce as _debounce, random as _random } from 'underscore';

export default class{

    constructor(options) {

        this.defaults = {
        	main 		: undefined,
        	$el 		: [],
        	index 		: 0,

        	delay_load  : 170,
        	addHistory 	: false,
        	//loadBeforeEnter: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'load-ajax-pagination';
		this.main			= this.options.main;
		this.$el 			= this.options.$el;
		this.index 			= this.options.index;

		this.init( true );
    }

    init( b ){
		this.initTriggerLoadAjaxContent( b );
		if ( b ){
			this.initURLS();
		}
    }

    getID(){
    	return this.namespace + '-' + this.index;
    }

	initTriggerLoadAjaxContent( b ){
		let $s;
		if ( this.$el.length > 0 ){
			$s = this.$el;

			if ( b ){

				if ( this.options.loadBeforeEnter ){
					if ( !$s.hasClass( 'ajax-loading' ) ){
						$s.addClass( 'ajax-loading' );
						this.loadAjaxContent( $s );
					}
				}

				ScrollTrigger.create({
					trigger: $s,
					// start: "top bottom", // the default values
					// end: "bottom top",
					scroller: $(this.main.options.$scroll_el),
					scrub: false,
					markers: false,
					id: this.getID(),
					//toggleClass: 'loaded-ajax',
					//once: true,
					onEnter:()=>{
						//if ( !this.options.loadBeforeEnter ) {
							if ( !$s.hasClass( 'ajax-loading' ) ){
								$s.addClass( 'ajax-loading' );
								this.timeout = setTimeout( ()=> this.loadAjaxContent( $s ), this.options.delay_load );
							}
						//}
					},

					/*
					onUpdate:(e)=>{
						if ( $s.hasClass( 'loaded-ajax' ) ){
							if ( e.direction === -1 ){
								if ( this.index === 0 && e.progress < 0.5 ){
									// SET FIRST PAGE !!!!!!!
									this.setCurrentPage(true);
								}
								if ( e.progress > 0.7 ){
									this.setCurrentPage()
								}									
							}
							else{
								if ( e.progress > 0.5 ){
									this.setCurrentPage()
								}
							}
						}
					}
					*/

				})

			}
			else{

				$s = ScrollTrigger.getById( this.getID() );
				if ( $s ){
					$s.kill();
				}
			
			}
		}
	}

	initURLS(){
		let $last = this.$el.find( '.last' ), 
			last = parseInt( $last.text() ),
			last_url = $last.attr( 'href' ),
			base_url;

		base_url = last_url.split( '/page/' )[0];


		console.log( base_url  + ' ---- ' + last );

	}

	getNextURLFormPagination(){

	}

	loadAjaxContent( $trigger ){


		console.log( 'QUIIIII' );


		let href 			= this.getNextURLFormPagination(), 

			target 			= $trigger.attr( 'data-target' ), 
			append_target 	= $trigger.attr( 'data-append-target' );


		if ( !href ){
			
			return;

		}

		this.main.setLoading( true );
		let $content, $append;

		$.ajax( href )
		.done( ( data ) =>{
			//console.log( data  );
			$content = $(data).find( '.' + target );

			if ( $content.length > 0 ){

				$append = $( '.' + append_target );

				if ( $append.length > 0 ){

					this.onLoadAjaxContent( href, $append, $content, data );					

				}
				else{
					console.log( 'Ajax load :: No append target found' );
				}
			}
			else{
				console.log( 'Ajax load :: No target content found' );
			}
		})
		.fail( () => {
			console.log( 'Ajax load :: error' );
		})
		.always( ()=> {
			this.main.setLoading( false );
			$trigger.addClass( 'loaded-ajax' );
		});

	}


	onLoadAjaxContent( href, $append, $content, data ){

		//console.log( data );

		let parser, doc;
		
    	parser = new DOMParser();
    	doc = parser.parseFromString( data, "text/html");
		
		this.$el.data( 'title', doc.title );
		this.$el.data( 'href', href );
		this.$el.data( 'post_title', $(data).find( '#hidden-page-title' ).html() );

		parser = doc = null;

		// add content
		$append.append( $content );

		// fade in
		gsap.fromTo( $content, {opacity:0}, {opacity:1, duration:0.8, ease: 'power.out'} );

		// call-back to main
		this.main.onLoadAjaxContent( href, this.$el, data, this.options.addHistory );
		
	}


	setCurrentPage( setFirstPage=false ){
		let history 	= window.history,
			index 		= this.index,
			title 		= this.$el.data('title'),
			post_title 	= this.$el.data('post_title'),
			href 		= this.$el.data('href'),
			origin;

		if ( setFirstPage && index === 0 ){
			origin 		= this.$el.data( 'origin' );
			index 		= -1;
			title 		= origin.title;
			post_title 	= origin.post_title;
			href 		= origin.href;
		}

		if ( history ){
			if ( history.state ){
				if ( history.state.id === index ){
					return;
				}
			}			
		}

		//console.log( 'setCurrentPage, is_first_page = ' +  setFirstPage + ' , title = ' + title );

		this.changeConpactNavTitle( post_title );
		this.changePageTitle( title );
		this.changeHistory( history, index, title, href );

	}

	changeHistory( history, index, title, href ){
		if ( history ){
			history.replaceState( { id: index }, title, href )
		} 				
	}

	changePageTitle( title ){
		$('title').text( title );
	}

	changeConpactNavTitle( post_title ){
		$( '#compact-nav .title' ).html( post_title );
	}

    destroy(){
    	this.init( false );
    }

}